module.exports = __webpack_public_path__ + "static/media/centre-appel4.792d72a7.png";